export default __webpack_public_path__ + "static/media/04LifeIsABitch60s.1813e1b4.mp3";